import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import { DemoReelCard, DemoReelCardProps } from './Cards/DemoReelCard';
import { IProject } from '../../types/global/helper';
import { ThemeStyle } from '../../module/ThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { AddIcon } from '@chakra-ui/icons';

interface ProjectListProps extends Pick<DemoReelCardProps, 'isEditMode' | 'onDelete' | 'onClickPlay'> {
    projects?: IProject[];
    themeStyle: ThemeStyle;
    isEditMode?: boolean;
    onAddNewItem?: () => void;
    title?: string;
    disableAddButton?: boolean;
}

const DemoReelGrid: React.FC<ProjectListProps> = ({
    projects,
    themeStyle,
    isEditMode,
    onAddNewItem,
    title,
    disableAddButton,
    ...props
}) => {
    if (!projects) {
        return <div />;
    }

    return (
        <Grid container spacing={2} mt={2}>
            <Typography
                sx={{ color: theme[themeStyle].tag_white, fontFamily: FONT_ENUM.MAIN_BOLD, fontSize: 16, px: 2 }}>
                {title ?? 'Demo Reel'}
            </Typography>
            {projects.map((project, index) => (
                <Grid item xs={12} key={index}>
                    <DemoReelCard project={project} isEditMode={isEditMode} {...props} />
                </Grid>
            ))}
            {isEditMode && !disableAddButton && (
                <IconButton
                    onClick={onAddNewItem}
                    sx={{
                        mt: 1,
                        width: '100%',
                        height: 100,
                        backgroundColor: theme[themeStyle].deep_grey_lighter,
                        borderRadius: '10px',
                        '&:hover': { backgroundColor: theme[themeStyle].deep_grey },
                    }}>
                    <AddIcon fontSize="large" sx={{ color: theme[themeStyle].tag_white }} />
                </IconButton>
            )}
        </Grid>
    );
};

export { DemoReelGrid };
